
// ApagarPage.js

import React, { useState, useEffect } from 'react';
import Header from '../../components/Header.js';
import { useTheme } from '../../contexts/ThemeContext.js';
import ExibirApagar from '../../components/ExibirApagar.js';
import CadastrarApagar from '../../components/CadastrarApagar.js';
import EditarApagar from '../../components/EditarApagar.js';
import ListarApagar from '../../components/ListarApagar.js';
import BotoesdeNavegacao from '../../components/BotoesdeNavegacao.js';
import BotoesDeAcao from '../../components/BotoesDeAcao.js';
import { useNavigate } from 'react-router-dom';
//import Axios from 'axios';
import api from '../../config/axiosConfig.js'; 
import '../../App.css';

function ApagarPage() {
  const { theme } = useTheme();
  // eslint-disable-next-line no-unused-vars
  const [apagar, setApagar] = useState([]);
  const [selectedApagar, setSelectedApagar] = useState("");
  const [showCadastroApagar, setShowCadastroApagar] = useState(false);
  const [showEditaApagar, setShowEditaApagar] = useState(false);
  const [showExibeApagar, setShowExibeApagar] = useState(false);
  const [showListaApagar, setShowListaApagar] = useState(false); // Estado para controlar a exibição do componente ListarApagar
  // eslint-disable-next-line no-unused-vars
  const [currentPage, setCurrentPage] = useState(1);
  // eslint-disable-next-line no-unused-vars
  const [totalPages, setTotalPages] = useState(1); // Inicialmente 1 página
  const [isSearchVisible, setIsSearchVisible] = useState(false);
  const [searchQuery, setSearchQuery] = useState({ codcompra: '', nomefor: '', cnpjfor: '' });
  const navigate = useNavigate(); // Definindo o useNavigate
  
// Função para Carregar as Contas a Pagar
const loadApagar = async (pageNumber = 1) => {
  console.log('Carregando Apagar...');
  try {
    // Primeiro, carregue a quantidade total de Contas a Pagar
    const countResponse = await api.get(`/apagar/listarapagar`);
    
    const totalApagar = countResponse.data.totalElements;
    const pageSize = 10; // Tamanho fixo da página
    const totalPages = Math.ceil(totalApagar / pageSize);
    
    // Solicite a última página de Conta a Pagar
    const lastPage = totalPages > 0 ? totalPages - 1 : 0;
    const response = await api.get(`/apagar/listarapagar/paginados?page=${lastPage}&size=${pageSize}`);
    
    setApagar(response.data.content);
    
    // Se houver Contas, selecione a última Conta a Pagar
    if (response.data.content.length > 0) {
      const lastApagar = response.data.content[response.data.content.length - 1];
      setSelectedApagar(lastApagar);
      setShowExibeApagar(true);
    }
    
    setTotalPages(totalPages);
  } catch (error) {
    console.error('Erro ao carregar Contas a Pagar:', error);
  }
  };
  
  
// Função para exibir Conta a Pagar selecionada
const handleIdClick = async (apagarId) => {
  try {
    handleSairListarClick(); // Fechar componente de listagem

    // Buscar a conta a Pagar pela ID única da parcela
    const response = await api.get(`/apagar/buscarapagar/${apagarId}`);
    
    if (response.data) {
      const apagar = response.data; // Você está buscando pelo ID, não precisa de array
      setSelectedApagar(apagar);
      setShowExibeApagar(true);
    } else {
      window.alert('Conta a Pagar não Encontrada.');
    }
  } catch (error) {
    console.error('Erro ao buscar Conta a Pagar:', error);
    window.alert('Erro ao buscar Conta a Pagar. Verifique o console para mais detalhes.');
  }
};
  
// Funções de navegação
// Função para buscar a primeira Conta a Pagar
const fetchPrimeiroApagar = async () => {
  try {
    const response = await api.get('/apagar/primeiro');
    
    if (response.data && response.data.codcompra) {
      console.log('Primeira Conta a Pagar Encontrada:', response.data);
      setSelectedApagar(response.data);
      setShowExibeApagar(true);
      } else {
        console.log('Nenhuma Conta a Pagar Cadastrada.');
        setSelectedApagar(response.data);
        setShowExibeApagar(true);
        window.alert('Nenhuma Conta a Pagar Cadastrada.');
      }
    } catch (error) {
      console.error('Erro ao buscar a Primeira Conta a Pagar:', error);
      setSelectedApagar("");
      setShowExibeApagar(true);
      window.alert('Nenhuma Conta a Pagar Cadastrada.');
    }
  };
  
// Função para buscar a Conta a Pagar Anteriorr
const fetchApagarAnterior = async () => {
  if (selectedApagar && selectedApagar.id) {
    console.log('Buscando compra anterior para o ID:', selectedApagar.id);
    try {
      const response = await api.get(`/apagar/anterior/${selectedApagar.id}`);
      
      if (response.data) {
        setSelectedApagar(response.data);
        setShowExibeApagar(true);
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        // Trata a resposta 404 como o primeiro registro encontrado
        window.alert('Primeiro Registro Encontrado.');
      } else {
        console.error('Erro ao buscar o Conta anterior:', error);
        window.alert('Erro ao buscar o registro anterior. Tente novamente.');
      }
    }
  } else {
    console.error('Nenhuma Conta selecionada ou Conta sem ID');
    window.alert('Nenhuma Conta selecionada para buscar o registro anterior.');
  }
};
  
// Função para buscar a compra posterior
const fetchApagarPosterior = async () => {
  if (selectedApagar && selectedApagar.id) {
    console.log('Buscando compra posterior para o ID:', selectedApagar.id);
    try {
      const response = await api.get(`/apagar/proximo/${selectedApagar.id}`);

      if (response.data) {
        setSelectedApagar(response.data);
        setShowExibeApagar(true);
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        // Trata a resposta 404 como o último registro encontrado
        window.alert('Último Registro Encontrado.');
      } else {
        console.error('Erro ao buscar o Conta posterior:', error);
        window.alert('Erro ao buscar o registro posterior. Tente novamente.');
      }
    }
  } else {
    console.error('Nenhuma Conta selecionada ou Conta sem ID');
    window.alert('Nenhuma Conta selecionada para buscar o registro posterior.');
  }
};
  

// Função para buscar a última Conta a Pagar
const fetchUltimoApagar = async () => {
  try {
    const response = await api.get('/apagar/ultimo');
    
    if (response.data) {
      //console.log('Última Conta encontrada:', response.data);
      setSelectedApagar(response.data);
      setShowExibeApagar(true);
    }
  } catch (error) {
    console.error('Erro ao buscar a última Conta:', error);
  }
};

  
  // Efeito para carregar a última Conta quando o componente for montado
    useEffect(() => {
    fetchUltimoApagar();
  }, [currentPage]);


  // Função para Buscar Apagar por Código da Compra.
  const fetchApagarPorCodcompra = async (codcompra) => {
    console.log('Buscando compra por Código da Compra:', codcompra);
    try {
      const response = await api.get(`/apagar/${codcompra}/apagar/primeira`, {
        headers: { 'Content-Type': 'application/json' },
        //, Authorization: `Bearer ${localStorage.getItem('token')}`
      });

    if (response.data) {
        console.log('Conta a Pagar encontrada por Código da Compra:', codcompra);
      setSelectedApagar(response.data);  // Acessa diretamente o objeto retornado
      console.log('Selected Apagar atualizado:', response.data);
      setShowExibeApagar(true);
      } else {
        console.warn('Conta a Pagar não encontrada por Código da compra: ', codcompra);
        window.alert('Conta a Pagar não encontrada por Código da compra: ', codcompra);
        fetchUltimoApagar();
      }
    } catch (error) {
      console.error('Erro ao buscar Conta a Pagar por Código da compra: ', error);
      window.alert('Conta a Pagar Não Encontrada por Código da compra: ', codcompra);
      fetchUltimoApagar();
    }
  };


  // Função para Buscar Conta a Apagar por Nome do Fornecedor
  //const fetchApagarPorNomefor = async (nomefor) => {
  //  console.log('Buscando Conta a Pagar mais recente por Nome do Fornecedor:', nomefor);
  //  try {
  //      const response = await Axios.get(`http://localhost:8080/compra/buscarapagar?nomefor=${nomefor}`);
  //      if (response.data) {
  //          console.log('Conta a Pagar encontrada por Nome do Fornecedor:', nomefor);
  //          setSelectedApagar(response.data);
  //          setShowExibeApagar(true);
  //      } else {
  //          console.warn('Conta a Pagar não encontrada por Nome do Fornecedor:', nomefor);
  //          window.alert('Conta a Pagar não encontrada por Nome do Fornecedor:', nomefor);
  //          fetchUltimoApagar();
  //      }
  //  } catch (error) {
  //      console.error('Erro ao buscar Conta a Pagar por Nome do Fornecedor:', error);
  //      window.alert('Erro ao buscar Conta a Pagar por Nome do Fornecedor');
  //      fetchUltimoApagar();
  //  }
  //};

  // Função para buscar Conta a Pagar mais recente por CNPJ do Fornecedor
  //const fetchApagarPorCnpjfor = async (cnpjfor) => {
  //  console.log('Buscando Conta a Pagar por CNPJ do Fornecedor:', cnpjfor);
  //  try {
  //      const response = await Axios.get(`http://localhost:8080/compra/buscarapagar?cnpjfor=${cnpjfor}`);
  //      if (response.data) {
  //          console.log('Conta a Pagar encontrada por CNPJ do Fornecedor:', cnpjfor);
  //          setSelectedApagar(response.data);
  //          setShowExibeApagar(true);
  //      } else {
  //          console.warn('Conta a Pagar não encontrada por CNPJ do Fornecedor:', cnpjfor);
  //          window.alert('Conta a Pagar não encontrada por CNPJ do Fornecedor:', cnpjfor);
  //          fetchUltimoApagar();
  //      }
  //  } catch (error) {
  //      console.error('Erro ao buscar Conta a Pagar por CNPJ do Fornecedor:', error);
  //      window.alert('Erro ao buscar Conta a Pagar por CNPJ do Fornecedor');
  //      fetchUltimoApagar();
  //  }
  //};

  // Função para listar Contas a Pagar cadastradas
  const handleListarClick = () => {
    setShowListaApagar(true); // Ao forcar no botão Listar, mostrar o componente ListarApagar
    setShowExibeApagar(false); // Esconder o componente ExibirApagar
  };

  // Função para sair do ListarApagar
  const handleSairListarClick = () => {
    setShowListaApagar(false); // Ao forcar no botão Sair do ListarApagar, esconder o componente ListarApagar
    setShowExibeApagar(true); // Mostrar novamente o componente ExibirApagar
  };

  // Função para cadastrar Nova Conta a Pagar
  //const handleNovoClick = () => {
  //  setSelectedApagar("");
  //  setShowCadastroApagar(true);
  //  setShowEditaApagar(false);
  //  setShowExibeApagar(false);
  //};

  // Função para Salvar Cadastro Nova conta a Pagar
  const handleSalvarNovaApagar = (apagar) => {
    setApagar([...apagar, apagar]);
    setSelectedApagar(apagar);
    setShowCadastroApagar(false);
    setShowExibeApagar(false);
    setShowEditaApagar(true);
    ///window.alert('Conta a Pagar Salva com Sucesso');
  };


  // Função para cancelar o cadastro da compra
  const handleCancelarNovaApagar = () => {
    setShowCadastroApagar(false);
    fetchUltimoApagar(); // Carrega a última Conta a Pagar da lista
    setShowExibeApagar(true);
  };



  // Função para editar Conta a Pagar Selecionada
  //const handleEditClick = () => {
  //  setShowEditaApagar(true);
  //  setShowCadastroApagar(false);
  //  setShowExibeApagar(false);
  //};


// Função para Salvar Conta a Pagar Exibida
const handleSaveApagar = async (apagarAtualizado) => {
  try {
    // Aqui você pode atualizar a lista de contas a Pagar sem duplicar
    setApagar((prev) =>
      prev.map((item) => (item.id === apagarAtualizado.id ? apagarAtualizado : item))
    );

    // Opcionalmente, faça uma nova requisição para garantir que os dados estão corretos
    //const response = await Axios.get(`http://localhost:8080/compra/buscarapagar/${apagarAtualizado.id}`);
    //const updatedApagar = response.data;

    // Atualize o estado com o registro atualizado
    //setSelectedApagar(updatedApagar);
    setShowExibeApagar(true);
    setShowEditaApagar(false);

    // Alerta opcional
    // window.alert('Conta a Pagar Editada com Sucesso');
  } catch (error) {
    console.error('Erro ao atualizar registro:', error);
    alert('Erro ao recarregar o registro atualizado.');
  }
};

  // Função para Salvar Conta a Pagar Editada
  const handleSalvaEditada = (apagar) => {
    setApagar([...apagar, apagar]);
    setSelectedApagar(apagar);
    setShowExibeApagar(true);
    setShowEditaApagar(false);
    //window.alert('Conta a Pagar Editada com Sucesso');
  };



  // Função para cancelar a edição da Conta a Pagar
  const handleCancelaEditada = () => {
    setShowCadastroApagar(false);
    setShowEditaApagar(false);
    setShowExibeApagar(true);
  };

  // Função para fechar a página de exibição e ir para a página inicial
  const handleCancelaExibe = () => {
    setShowCadastroApagar(false);
    setShowEditaApagar(false);
    setShowExibeApagar(false);
    setApagar(""); // Reseta o estado da compra
    navigate('/home'); // Redireciona para a página inicial
  };


const handleDeleteClick = async () => {
  if (selectedApagar) {
    const confirmation = window.confirm(`Tem certeza que deseja excluir a Conta ${selectedApagar.id}?`);
    if (confirmation) {

      // Procede com a exclusão da Conta a Pagar
      await api.delete(`/apagar/${selectedApagar.id}`, {
        headers: { 'Content-Type': 'application/json' },
        //, Authorization: `Bearer ${localStorage.getItem('token')}`
      });

      window.alert(`Apagar: ${selectedApagar.id} Excluída com Sucesso.`);

      // Carregar compras novamente
      loadApagar(currentPage);
      // Buscar e exibir a última Conta a Pagar
      fetchUltimoApagar();
      
    }
  } else {
    console.error('Nenhuma Conta a Pagar selecionada para excluir');
  }
};

// Se os campos de busca estiverem sendo exibidos, limpa os campos de busca
  const handleSearchClick = () => {
    if (!isSearchVisible) {
    setSearchQuery({ codcompra: '', nomefor: '', cnpjfor: '' });
  }
    setIsSearchVisible(!isSearchVisible);
  };
  

// A função handleSearchChange faz a busca apenas quando a tecla Enter é pressionada
  const handleSearchChange = (e) => {
    const { name, value } = e.target;
    setSearchQuery({ ...searchQuery, [name]: value });
  };


  // Se a tecla pressionada for Enter, executar a busca
  const handleSearchByCodigo = (e) => {
    if (e.key === 'Enter') {
      fetchApagarPorCodcompra(searchQuery.codigo);
    }
  };

  //const handleSearchByNome = (e) => {
  //  if (e.key === 'Enter') {
  //    fetchApagarPorNomefor(searchQuery.nome);
  //  }
  //};

  //const handleSearchByCNPJ = (e) => {
  //  if (e.key === 'Enter') {
  //    fetchApagarPorCnpjfor(searchQuery.cnpj);
  //  }
  //};


  return (
    <div
      style={{
        backgroundColor: theme.background,
        color: theme.color,
        minHeight: 'calc(100vh - 20px)',
        width: '100%',
        paddingTop: '10px',
        textAlign: 'center',
      }}
    >
      <Header selectedEmpresa={localStorage.getItem('selectedEmpresa')} />


{!showCadastroApagar && selectedApagar && !showEditaApagar && showExibeApagar && (
  <>
    <BotoesdeNavegacao
      fetchPrimeiro={fetchPrimeiroApagar}
      fetchAnterior={fetchApagarAnterior}
      fetchProximo={fetchApagarPosterior}
      fetchUltimo={fetchUltimoApagar}
    />
    <BotoesDeAcao
      //handleNovoClick={handleNovoClick}
      //handleEditClick={handleEditClick}
      handleDeleteClick={handleDeleteClick}
      handleSearchClick={handleSearchClick}
      handleListarClick={handleListarClick} // Verifique se handleListarClick está passada corretamente
      isSearchVisible={isSearchVisible}
      handleSearchChange={handleSearchChange}
      handleSearchByCodigo={handleSearchByCodigo}
      //handleSearchByNome={handleSearchByNome}
      //handleSearchByCNPJ={handleSearchByCNPJ}
      searchQuery={searchQuery}
    />
    <ExibirApagar
      apagar={selectedApagar || {}}
      handleSaveApagar={handleSaveApagar}      
      handleCancelaExibe={handleCancelaExibe} 
      />
      </>
      )}
      
      {showListaApagar && (
        <ListarApagar
        onIdClick={handleIdClick} // Corrigindo para passar a função onIdClick
        handleSairListarClick={handleSairListarClick}
        />
      )}


      {showCadastroApagar && (
        <CadastrarApagar
          handleSaveClick={handleSalvarNovaApagar}
          //handleCloseClick={handleFecharNovaApagar}
          handleCancelaClick={handleCancelarNovaApagar}
          apagar={selectedApagar}
        />
      )}

      
      {showEditaApagar && (
      <EditarApagar
      apagar={selectedApagar}
      handleEditClick={handleSalvaEditada}
      handleCancelaEdit={handleCancelaEditada}
      />
      )}
      
  </div>
  );
}

export default ApagarPage;